import { Elastic, gsap } from 'gsap';
import ParticleSystem from 'Engine/particles/particleSystem';
import particleConfig from 'Engine/particles/particleConfig';
import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import FlashLib from 'flashlib_onlyplay';
import animationCreator from 'Engine/animations/animationCreator';
import { shadowText, whiteYellowOrange } from '../../textStyles/styles';
import { getRandom } from 'Engine/utils/getRandom';
import MoneyFormat from 'Engine/base/moneyFormat/MoneyFormat';
import eAnimationTypes from '../../enums/eAnimationTypes';
import eEventTypes from '../../enums/eEventTypes';
import EntryPoint from 'Engine/EntryPoint';

export default class ControllerBonusPurchaseCard extends FlashLib.MovieClip {
  constructor(data, displayData) {
    super(data, displayData);

    this.init();
    this.initParticles();
    this.setTextStyle();
    this.addListeners();
    this.onResize();

    this._disabled = false;
    this._animations = null;
    this.cardAnimationClickInScale = 0.16;
    this.cardAnimationScaleDuration = 0.4;
    this.cardAnimationTimeStart = null;

    this._checkCardAvailability = this._checkCardAvailability.bind(this);
  }

  init() {
    this.animationContainer = this.getChildByName('animationContainer');

    this.label = this.getChildByName('purchase_card_label');
    while (this.label.origWidth > this.label.width) {
      this.label.style.fontSize--;
    }
    this.label.correctPosition('center', null);

    this.label.pivot.set(this.label.width / 2, this.label.height / 2);
    this.label.x += this.label.width / 2;
    this.label.y += this.label.height / 2;

    this.pricePanel = this.getChildByName(`pricePanel`);
    this.pricePanel.pivot.set(this.pricePanel.width / 2, this.pricePanel.height / 2);
    this.pricePanel.x += this.pricePanel.width / 2;
    this.pricePanel.y += this.pricePanel.height / 2;

    this.priceText = this.pricePanel.getChildByName('text');

    this.buyButton = this.getChildByName('btnBuy');
    this.makeHitArea(this.buyButton);

    this.buyButtonText = this.buyButton.getChildByName('purchase_btn_buy_label');
    this.buyButtonText.correctPosition('center', 'center');
    this.buyButton.pivot.set(this.buyButton.width / 2, this.buyButton.height / 2);
    this.buyButton.x += this.buyButton.width / 2;
    this.buyButton.y += this.buyButton.height / 2;

    this.clicked = false;
    this.eventMode = 'static'
    this.checkButtonEnabled();
  }

  makeHitArea(el) {
    el.hitArea = new PIXI.Rectangle(0, 0, el.width, el.height);
  }

  initButtonAnimation() {
    if (this.btnAnimation) return;

    this.btnAnimation = animationCreator.createAnimation(eAnimationTypes.EAT_PURCHASE);
    if (!this.btnAnimation) return;

    this.btnAnimation.state.addListener({
      complete: this.loopButtonAnimation.bind(this)
    });

    this.btnAnimation.state.setAnimation(0, 'buy_button_side', false);
    this.buyButton.animation = this.btnAnimation;
  }

  loopButtonAnimation() {
    const delay = getRandom(5000, 10000);
    this.btnAnimationTimeout = setTimeout(() => {
      this.btnAnimation.state.setAnimation(0, 'buy_button_side', false)
    }, delay)
  }

  initCardAnimation() {
    if (!this._animations) return;

    this.cardAnimation = animationCreator.createAnimation(eAnimationTypes.EAT_PURCHASE);

    this.cardAnimation.state.setAnimation(0, this._animations.idle, true);

    this.cardAnimation.eventMode = 'static'
    this.cardAnimation.hitArea = new PIXI.Rectangle(
      -202,
      -310,
      404,
      510
    );
    this.animationContainer.addChild(this.cardAnimation);

    this.cardAnimation.on('mouseover', this.onAnimationOver, this);
    this.cardAnimation.on('mouseout', this.onAnimationOut, this);
    this.cardAnimation.on('pointertap', this.onAnimationClick, this);
    this.scaledItems = [this.cardAnimation.scale, this.pricePanel.scale, this.label.scale, this.buyButton.scale];
  }

  addListeners() {
    window.addEventListener('resize', () => setTimeout(this.onResize.bind(this), 1));

    this.buyButton.addListener('pointertap', this.onAnimationClick.bind(this));
    this.buyButton.addListener('mouseover', this.onAnimationOver.bind(this));
    this.buyButton.addListener('mouseout', this.onAnimationOut.bind(this));
  };

  addDisableListener() {
    GlobalDispatcher.add(eEventTypes.EET_BET_CHANGED, this._checkCardAvailability);
  }

  removeDisableListener() {
    GlobalDispatcher.remove(eEventTypes.EET_BET_CHANGED, this._checkCardAvailability);
  }


  onResize() {
    const width = Math.min(window.innerWidth, window.outerWidth);
    const height = Math.min(window.innerHeight, window.outerHeight);
    const isHorizontalOrientation = (width - height) > 0;

    if (PIXI.utils.isMobile.any && isHorizontalOrientation) {
      switch (this.index) {
        case 0:
          this.x = this.displayData.x;
          break;
        case 1:
          this.y = this.displayData.y;
          break;
        case 2:
          this.x = this.displayData.x;
          break;
      }
    } else if (PIXI.utils.isMobile.any) {
      switch (this.index) {
        case 0:
          this.x = this.displayData.x + 60;
          break;
        case 1:
          this.y = this.displayData.y + 200;
          break;
        case 2:
          this.x = this.displayData.x - 60;
          break;
      }
    }
  };

  checkButtonEnabled() {
    // this.buyButton.enabled = GameModel.balance >= this._price;
    this.buyButton.enabled = true
  }

  updateLabel(label) {
    this.label.text = label;
  }

  updatePrice() {
    this._price = EntryPoint.GameModel.getBonusPurchasePrice(this._type);
    this.priceText.text = MoneyFormat.format(this._price, true);
    // this.checkButtonEnabled()
  };

  onAnimationOver() {
    if (this.clicked || this._disabled) return;
    gsap.killTweensOf(this.scaledItems);
    gsap.to(this.scaledItems, {
      x: 1.08,
      y: 1.08,
      duration: this.cardAnimationScaleDuration
    });
  };

  onAnimationOut() {
    if (this.clicked || this._disabled) return;
    gsap.killTweensOf(this.scaledItems);
    gsap.to(this.scaledItems, {
      x: 1,
      y: 1,
      duration: this.cardAnimationScaleDuration
    });
  };

  onAnimationClick() {
    if (this.clicked || this._disabled) return;
    this.clicked = true;

    this.cardAnimation.state.setAnimation(0, this._animations.action, false);
    this.cardAnimation.state.addListener({
      complete: () => {
        this.cardAnimation.state.setAnimation(0, this._animations.idle, true);
      }
    });

    gsap.killTweensOf(this.scaledItems);

    this._animateClickIn();
  };

  setTextStyle() {
    this.label.style = { ...this.label.style, ...whiteYellowOrange };
    this.buyButtonText.style = { ...this.buyButtonText.style, ...shadowText };
  }

  _animateClickIn() {
    const scale = 0.16;
    this.cardAnimationTimeStart = Date.now();
    gsap.to(this.scaledItems, {
      x: this.cardAnimation.scale.x - scale,
      y: this.cardAnimation.scale.y - scale,
      duration: 0.1,
      onComplete: this._animateClickOut.bind(this),
    });
  };

  _animateClickOut() {
    gsap.to(this.scaledItems, {
      ease: Elastic.easeOut.config(1, 0.3),
      x: this.cardAnimation.scale.x + this.cardAnimationClickInScale / 2,
      y: this.cardAnimation.scale.y + this.cardAnimationClickInScale / 2,
      duration: 1,
      onUpdate: this._onAnimationUpdate.bind(this),
      onComplete: this.onAnimationOut.bind(this),
    });
  };

  _onAnimationUpdate() {
    if (!this.clicked) return;
    if (Date.now() - this.cardAnimationTimeStart >= 0.6 * 1000) {
      this._onClickCallback();
    }
  }

  _onClickCallback() {
    this.clicked = false;
    GlobalDispatcher.dispatch(eEventTypes.EET_PURCHASE_CONFIRM, { price: this._price, type: this._type })
  }

  initParticles() {
    const texture = PIXI.Texture.from('starsParticle');
    const width = 300;
    const container = new PIXI.Container();
    container.pivot.x = width / 2;
    container.x = this.displayData.width / 2;
    container.y = -280;

    this.particles = new ParticleSystem(container, { texture: texture }, {
      ...particleConfig.defaultConfig,
      x0max: width
    });

    this.particles.visible = false;
    this.addChildAt(container, 0);
  }

  show() {
    this.initCardAnimation();
    this.showParticles();
    this.addDisableListener();
    this._checkCardAvailability();
  }

  showParticles() {
    this.particles.visible = true;
    this.particles.start();
  };

  beforeUnload() {
    this._clearButtonAnimation();
    this._clearCardAnimation();
    this.stopParticles();
    this.removeDisableListener();
  }

  stopParticles() {
    this.particles.stop();
  }

  _checkCardAvailability() {
    this._disabled = !EntryPoint.GameModel.isPurchaseCardAvailable(this._type);
    if (this._disabled) {
      this.cardAnimation.buttonMode = false;
      this.buyButton.enabled = false;
      this.buyButton.tint = 0x666666;
      this.buyButtonText.tint = 0x666666;
      this._clearButtonAnimation();
    } else {
      this.cardAnimation.buttonMode = true;
      this.buyButton.enabled = true;
      this.buyButton.tint = 16777215;
      this.buyButtonText.tint = 16777215;
      this.visible && this.initButtonAnimation();
    }
  }

  _clearCardAnimation() {
    if (this.cardAnimation) {
      this.cardAnimation.destroy();
      this.cardAnimation = null;
    }
  }

  _clearButtonAnimation() {
    if (this.btnAnimationTimeout) clearTimeout(this.btnAnimationTimeout);
    if (this.btnAnimation) {
      this.btnAnimation.destroy();
      this.btnAnimation = null;
    }
  }

  set data(data) {
    this.type = data.type;
    this.updateLabel(data.label);
    this._animations = data.animations;
  }

  set type(type) {
    this._type = type;
  }

  set disabled(value) {
    this._disabled = value;
  }
}
